import { useTheme } from '@mui/material';

export const WalletIcon = () => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            width={58}
            height={58}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={primaryIconStrokeColor}
                d="M45 12.782a6 6 0 0 1 5.928 5.072A6.002 6.002 0 0 1 56 23.782v18a6 6 0 0 1-6 6H29.976v-2H50a4 4 0 0 0 4-4v-3h-4.538l-.436-.01A8.462 8.462 0 0 1 41 30.32a2.538 2.538 0 0 1 2.538-2.538H54v-4a4 4 0 0 0-4-4H11v22a4 4 0 0 0 4 4h3.88v2H15l-.309-.008a6 6 0 0 1-5.683-5.683L9 41.782v-27a2 2 0 0 1 2-2h34Zm-1.462 17a.538.538 0 0 0-.538.538 6.462 6.462 0 0 0 6.462 6.462H54v-7H43.538Zm3.462 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm-36-13h37.874a4.002 4.002 0 0 0-3.874-3H11v3Z"
            />
        </svg>
    );
};
